import React from "react";
import SingletonEditor from "./SingletonEditor";

const fields = [
  { key: "company_name", label: "Company Name" },
  { key: "tagline", label: "Tagline" },
  { key: "email", label: "General Contact Email", type: "email", help: "Receives general inquiries from the contact form" },
  { key: "quote_email", label: "Quote Request Email", type: "email", help: "Receives all quote requests (any project type other than 'Other / General Inquiry')" },
  { key: "phone", label: "Phone Number" },
  { key: "address_line1", label: "Street Address (line 1)", help: "e.g. 476 Highway A1A, Suite 8B" },
  { key: "address_line2", label: "City, State ZIP", help: "e.g. Satellite Beach, FL 32937" },
  { key: "mailing_address", label: "Mailing / PO Box", help: "e.g. PO Box 372913 Satellite Beach, FL 32937" },
  { key: "hours", label: "Business Hours", type: "textarea", rows: 4, help: "One line per row" },
  { key: "footer_blurb", label: "Footer Description", type: "textarea", rows: 4 },
];

const SettingsEditor = () => (
  <SingletonEditor
    resource="settings"
    title="Site Settings"
    eyebrow="Global"
    fields={fields}
    testIdPrefix="settings-edit"
  />
);
export default SettingsEditor;
